import React from 'react'
import { Formik, Form } from 'formik';
import CircuitColumns from './VisiblityFilterForms/CircuitColumns';

export default function CircuitColumnForm({ isLoading, handleSubmit, setModal, visibleCols }) {


    return (
        <Formik
            initialValues={visibleCols}
            onSubmit={handleSubmit}
        // enableReinitialize={true}
        >
            {formik => (

                <Form>
                    <CircuitColumns
                        formik={formik}
                        isLoading={isLoading}
                        setModal={setModal}
                        visibleCols={visibleCols}
                    />
                </Form>
            )}
        </Formik>
    )
}
